import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { CognitoPool, Organization } from 'views/App/Portal/LexID/Organizations/_types/organization';

export const getOrganization = async (
  id: string,
  signal?: AbortSignal | undefined,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexid/admin-org/v1/organizations/${id}`;
  if (id === 'LexipolGenesisRoot') {
    const rootOrg: Organization = {
      organization: {
        id: 'LexipolGenesisRoot',
        name: 'Lexipol (Root)',
        groupCount: 1,
        roleCount: 1,
        userCount: 1,
        status: 'active',
      },
      cognitoPool: {} as CognitoPool,
    };
    return rootOrg;
  }

  try {
    const data = await fetcher({
      method: 'get',
      url,
      options: { signal },
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useOrganization(id: string, options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<Organization, ServerErrorResponse>(
    ['organization', id],
    async ({ signal }) => {
      if (!id) {
        return null;
      }
      return getOrganization(id, signal, onError);
    },
    {
      keepPreviousData: false,
      enabled: !!id,
      ...options,
    }
  );
}
